import { ChangeOrderDeliveryStatusByMarkerRequest } from '@/Api/MpOrdersMarking/Requests/ChangeOrderDeliveryStatusByMarkerRequest';
import { DateFormatType, OrderStatusFilterGroups } from '@/Enums';
import { OrderMarker } from '@/Enums/OrderMarker';
import { useForm } from '@/Hooks/useFormWrapper';
import { dateTimeUtils } from '@/Utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { salesPageActions } from '@/Pages/Sales/services';
import { useRequired } from '@/Hooks/Validation';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { changeDeliveryAsyncActions } from '../services/asyncActions';

type FormData = ChangeOrderDeliveryStatusByMarkerRequest;

export const useAllNotShippedForm = (orderIds: number[], onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      orderMarker: OrderMarker.Paid,
      orderIds,
      shippingDate: dateTimeUtils.getCurrentDateTime(DateFormatType.LOCAL_DATE_TIME),
    },
  });

  // Rules
  const required = useRequired();

  const submit = useCallback(
    (data: FormData) => {
      onClose();

      dispatch(
        changeDeliveryAsyncActions.changeDeliveryNotShippedStatus({
          ...data,
          shippingDate: dateTimeUtils.localStringToUtcString(data?.shippingDate),
          orderMarker: OrderMarker.Shipped,
        }),
      ).then(() => {
        // remove sales from table if current filters is notShipped
        dispatch(
          salesPageActions.removeOrdersFromStateByCurrentFilters({
            orderIds: orderIds,
            filters: OrderStatusFilterGroups.NotShippedGroup,
          }),
        );
      });
    },
    [orderIds],
  );

  return {
    methods: {
      onSubmit: handleSubmit(submit),
      register,
      setValue,
    },
    rules: {
      required,
    },
    errors,
  };
};
